module.exports = __webpack_public_path__ + "files/aaba1390c285cb2f2537054fdcc0c972.png";